import { t } from '../../i18n';

export const OTHER_CATEGORY_ID = 'other';

export const groupReportsByCategory = (reports = [], categories = []) => {
    const byCategory = new Map();

    reports.forEach((report) => {
        const key = report.category?.id ?? OTHER_CATEGORY_ID;
        if (!byCategory.has(key)) byCategory.set(key, []);
        byCategory.get(key).push(report);
    });

    const sections = categories
        .filter((category) => byCategory.has(category.id))
        .map((category) => ({
            id: category.id,
            label: category.label,
            reports: byCategory.get(category.id),
        }));

    const orphans = byCategory.get(OTHER_CATEGORY_ID);
    if (orphans?.length) {
        const label = t('reportsPage.otherReports');
        sections.push({
            id: OTHER_CATEGORY_ID,
            label,
            reports: orphans.map((report) => ({
                ...report,
                category: { id: OTHER_CATEGORY_ID, label },
            })),
        });
    }

    return sections;
};

export default groupReportsByCategory;
